import React, { useContext } from "react";
import { AuthContext } from "../../Context/AuthContextProvider";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import "./SellIntro.css";
import { GoBroadcast } from "react-icons/go";
import { RiPagesFill } from "react-icons/ri";
import { IoIosPricetags } from "react-icons/io";
import { FaWallet } from "react-icons/fa";

const sellFeatures = [
  {
    icon: <IoIosPricetags className="text-[#1a2a5e] w-6 h-6" />,
    title: "Right Prices",
    description:
      "We ensure that your domain gets a top price on our marketplace",
  },
  {
    icon: <GoBroadcast className="text-[#1a2a5e] w-6 h-6" />,
    title: "Broad Exposure",
    description: "You can reach more than 10,000 potential buyers every day",
  },
  {
    icon: <FaWallet className="text-[#1a2a5e] w-6 h-6" />,
    title: "Low Charges",
    description:
      "You will be charged very less considering our highest quality services",
  },
  {
    icon: <RiPagesFill className="text-[#1a2a5e] w-6 h-6" />,
    title: "Homepage Spotlight",
    description:
      "Your domain will appear on our homepage as a premium .gold domain.",
  },
];

function SellIntro() {
  const { isAuth } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleClick = () => {
    if (isAuth) {
      navigate("/post-dot-gold-domain");
    } else {
      toast.error("You must log in to list your domain");
      navigate("/login");
    }
  };

  return (
    <section className="bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 py-12 md:pt-32">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        {/* Main Card */}
        <div className="bg-white rounded-3xl shadow-xl border border-blue-100 overflow-hidden">
          {/* Header Section */}
          <div className="bg-gradient-to-r from-[#101c4c] to-[#1a2a5e] px-8 md:px-12 py-10 md:py-12">
            <div className="max-w-3xl">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-4">
                Get the{" "}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#fcdb6a] to-[#b99653]">
                  best possible price
                </span>
              </h1>

              <p className="text-base sm:text-lg text-gray-300 leading-relaxed mb-6">
                Sell your domain quickly at the right price while taking
                advantage of particularly low selling fees.
              </p>

              <button
                className="inline-flex items-center justify-center px-8 py-3 rounded-xl font-bold shadow-lg bg-gradient-to-r from-[#b99653] to-[#fcdb6a] text-white hover:shadow-xl hover:scale-105 transition-all duration-300"
                onClick={handleClick}
              >
                List Your Domain
              </button>
            </div>
          </div>

          {/* Features Section */}
          <div className="px-8 md:px-12 py-10 md:py-12">
            <h2 className="text-2xl md:text-3xl font-bold text-[#101c4c] mb-8 text-center">
              Why Choose Us?
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {sellFeatures.map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center text-center p-6 rounded-2xl bg-gradient-to-br from-white to-gray-50 border border-gray-200 shadow-md hover:shadow-lg hover:-translate-y-1 transition-all duration-300"
                >
                  {/* Icon */}
                  <div className="mb-4 p-4 rounded-xl bg-gradient-to-br from-[#fcdb6a] to-[#b99653]">
                    {feature.icon}
                  </div>

                  {/* Title */}
                  <h3 className="text-lg font-bold text-[#101c4c] mb-2">
                    {feature.title}
                  </h3>

                  {/* Description */}
                  <p className="text-sm text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SellIntro;
